import React, { ComponentType } from "react";

import Dropdown from "antd/es/dropdown";
import Menu from "antd/es/menu";
import { useIntl } from "react-intl";

import Identified from "@mapmycustomers/shared/types/base/Identified";

import MoreButton from "@app/component/MoreButton";
import TextWithInfo from "@app/component/typography/TextWithInfo";

import BoardColumn from "../types/BoardColumn";
import ColumnHeaderProps from "../types/ColumnHeaderProps";

import styles from "./ColumnHeaderCommon.module.scss";

interface Props<DataType, ItemType extends Identified> {
  column: BoardColumn<DataType, ItemType>;
  columnSubHeader?: ComponentType<ColumnHeaderProps<DataType, ItemType>>;
  onHide?: (column: BoardColumn<DataType, ItemType>) => void;
}

const ColumnHeader = <DataType, ItemType extends Identified>({
  column,
  columnSubHeader: ColumnSubHeader,
  onHide,
}: Props<DataType, ItemType>) => {
  const intl = useIntl();

  return (
    <div className={styles.container}>
      <div className={styles.top}>
        <div className={styles.top}>
          <span className={styles.title}>
            {column.name} ({column.total ?? 0})
          </span>
          <span>
            {column.infoTooltip && (
              <TextWithInfo className={styles.infoIcon} info={column.infoTooltip} />
            )}
          </span>
        </div>
        <Dropdown
          overlay={
            <Menu>
              <Menu.Item onClick={() => onHide?.(column)}>
                {intl.formatMessage({
                  id: "dndBoard.column.header.menu.hide",
                  defaultMessage: "Hide",
                  description: "Deal DND board column menu - hide column",
                })}
              </Menu.Item>
              {column.menuItems}
            </Menu>
          }
          trigger={["click"]}
        >
          <MoreButton size="small" />
        </Dropdown>
      </div>
      {ColumnSubHeader && <ColumnSubHeader column={column} />}
    </div>
  );
};

export default ColumnHeader;
